import React from 'react';
import { useForm } from 'react-hook-form';
import { Flex } from '@chakra-ui/react';
import { Modal, Button } from '@morressier/alembic';
import _ from 'lodash';
import { FormFieldDataAvailability, FormFieldDateInput, FormFieldRadio, FormFieldTextInput } from '@publishing-engine/domain/types/article';
import DataAvailabilityFormItem, { IDataAvailabilityForm } from './FormItem';
import { IDependentValue } from '@publishing-engine/domain/models';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSave: (value: IDataAvailabilityForm) => void;
  config: FormFieldDataAvailability;
  defaultValue?: IDependentValue<string>;
  DataAvailabilityOpenlyAvailableUrlConfig?: FormFieldTextInput<'preference.dataAvailabilityOpenlyAvailableUrl'>;
  DataAvailabilityEmbargoUrlConfig?: FormFieldTextInput<'preference.dataAvailabilityEmbargoUrl'>;
  DataAvailabilityEmbargoDateConfig?: FormFieldDateInput<'preference.dataAvailabilityEmbargoDate'>;
  DataUnavailabilityReasonConfig?: FormFieldRadio<'preference.dataUnavailabilityReason'>;
}

const EditModal: React.FC<Props> = props => {
  const { isOpen, onClose, onSave, config, DataAvailabilityOpenlyAvailableUrlConfig, DataAvailabilityEmbargoUrlConfig, DataAvailabilityEmbargoDateConfig, DataUnavailabilityReasonConfig } = props;

  const defaultValues = _.set(
    {} as IDataAvailabilityForm,
    config.caseDataFields.main,
    props.defaultValue
  );

  const {
    formState: { errors },
    handleSubmit,
    getValues,
    watch,
    control
  } = useForm({
    defaultValues
  });

  const onSubmit = () => {
    onSave(getValues());
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width="755px"
      closeButtonProps={{
        hidden: true
      }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex
          padding={8}
          gap={6}
          bgColor="surfacePrimaryFill"
          flexDirection="column"
          borderRadius="base"
        >
          <Flex maxHeight={700} overflow={'auto'}>
            <DataAvailabilityFormItem
              config={config}
              control={control}
              errors={errors}
              watch={watch} 
              DataAvailabilityOpenlyAvailableUrlConfig={DataAvailabilityOpenlyAvailableUrlConfig}
              DataAvailabilityEmbargoUrlConfig={DataAvailabilityEmbargoUrlConfig}
              DataAvailabilityEmbargoDateConfig={DataAvailabilityEmbargoDateConfig}
              DataUnavailabilityReasonConfig={DataUnavailabilityReasonConfig}
            />
          </Flex>
          <Flex
            gap={2}
            justifyContent="flex-end"
            alignItems="center"
            alignSelf="stretch"
          >
            <Button variant="secondary" onClick={onClose} borderRadius="small">
              Cancel
            </Button>
            <Button variant="primary" type="submit" borderRadius="small">
              Save Changes
            </Button>
          </Flex>
        </Flex>
      </form>
    </Modal>
  );
};

export default EditModal;
